import * as React from 'react'
import { Text } from '$views/components'
import {
  StyledIconWithTextContainer,
  IconBackground,
  StyledIconText,
} from '$views/components/IconWithText/IconWithText.style'
import { Block } from '$views/components/Layout/Block'
import { Icon } from '$views/components/Icon'

interface Props {
  label?: string
  iconSrc?: string
  iconText?: string
  onClick: () => void
  iconColor?: string
  backgroundColor?: string
}

export const IconWithText: React.SFC<Props> = ({ label, iconSrc, iconText, onClick, iconColor, backgroundColor }) => {
  return (
    <StyledIconWithTextContainer onClick={onClick}>
      <Block textAlign="center">
        <IconBackground backgroundColor={backgroundColor}>
          {iconSrc ? (
            <Icon size="ml" marginRight="none" content={iconSrc} color={iconColor} />
          ) : (
            <StyledIconText title>{iconText}</StyledIconText>
          )}
        </IconBackground>
        {label && (
          <Text capitalize marginTop="tiny" weight="medium" color="menu" menu>
            {label}
          </Text>
        )}
      </Block>
    </StyledIconWithTextContainer>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/IconWithText/IconWithText.tsx